import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 100%;
    min-height: 40px;
    align-items: center;
    background-color: #ffffff;
    padding-left: .2rem;
    cursor: pointer;
    border-radius: 4px;
    &:hover{
        background: ${({ theme }) => theme.colors.__gray[250]};
    }
`;
export const Logo = styled.div`
    display: flex;
    width: 30px;
    border-radius: 50%;
    img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: contain;
    }
`;
export const Name = styled.div`
    display: flex;
    width: calc(100% - 30px);
    max-width: calc(100% - 35px);
    margin-left: 5px;
    justify-content: left;
    overflow: hidden;
    font-size: .899rem;
    white-space: nowrap; /* Evita que o texto quebre em várias linhas */
    text-overflow: ellipsis; /* Adiciona reticências quando o texto é cortado */
`;